export const LicenseCategoryRouting = [
  {
    path: "/license-manage/license-category/list",
    name: "license-category-list",
    meta: { title: "证照分类" },
    component: () => import("@/views/license-manage/license-category/list/index.vue"),
  }
];
